import { Injectable } from '@angular/core';
import { AgencyDatePipe } from '../pipes/agency-date.pipe';

@Injectable()
export class HistoryItemService {
  constructor(private agencyDatePipe: AgencyDatePipe) {}

  public formatHistoryComment(comment = '') {
    if (comment) {
      const splittedComment = comment.split(' ');

      if (splittedComment[0].toLowerCase() === 'date' && splittedComment.length === 3) {
        return `Date - ${this.agencyDatePipe.transform(new Date(`${splittedComment[1]}T${splittedComment[2]}`))}`;
      }

      return comment;
    }

    return '';
  }
}
